module.exports = __webpack_public_path__ + "img/2.41c96cbc.jpg";